import { render } from "./ResultRankingKeizer.vue?vue&type=template&id=76311952&scoped=true"
import script from "./ResultRankingKeizer.vue?vue&type=script&lang=js"
export * from "./ResultRankingKeizer.vue?vue&type=script&lang=js"

import "./ResultRankingKeizer.vue?vue&type=style&index=0&id=76311952&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76311952"]])

export default __exports__